// import CRDashboardIcon from "../../../assets/icons/CRDashboard.svg"
import KaliIcon from "../../../assets/icons/Kali.svg"
import WindowsIcon from "../../../assets/icons/Windows.svg"
import UbuntuIcon from "../../../assets/icons/Ubuntu.svg"
import ParallelIcon from "../../../assets/icons/Parallel.svg"
import RefreshIcon from "../../../assets/icons/Refresh.svg"
import FullTevelLogo from "../../../assets/img/TevelCyberFinalWhiteLogo.png"
import MiniTevelLogo from "../../../assets/img/TevelwhiteLogo.png"
import CyberBayLogo from "../../../assets/img/CyberBayWhite.png"
import { useEffect, useState } from "react"
// import FullScreenIcon from '../../../assets/icons/FullScreen.svg'
// import MinimizeIcon from '../../../assets/icons/Minimize.svg'

const SplitView = ({ isFullScreen, totalTime, isCollapsed, setIsCollapsed, setSplitView,   focusIframe, vmList, showVM, setIsParallel, refreshIframe, toggleFullscreen, isParallel, containerRef, dragOverlayRef, activePane, leftPaneRef, leftWidth, handlePaneFocus, leftIframeRef, iframeKey, vmUrl1, dividerRef, rightPaneRef, rightIframeRef, vmUrl2, vmUrl, singleIframeRef, handleIframeLoad
}) => {
  const [hrs, mins, secs] = totalTime?.split(":") || ["00", "00", "00"];
  const [activeVM, setActiveVM] = useState(null);
  useEffect(() => {
  if (vmList && vmList.length > 0) {
    setActiveVM(vmList[0].connectionId);
  }
}, [vmList]);

    return (
        <div className={`dashboard-layout ${isFullScreen ? 'fullscreen-mode' : ''}`}>
            <div className={`left-pane ${isCollapsed ? 'pane-collapsed' : ''}`} onMouseDown={(e) => {
    e.preventDefault();
    focusIframe();
  }}>
                <button className="collapse-toggle" id="collapseBtn" 
  onMouseDown={(e) => e.stopPropagation()} 
  onClick={(e) => {
  e.preventDefault();
  setIsCollapsed(!isCollapsed);

  setTimeout(() => {
    if (!isParallel && singleIframeRef.current) {
      singleIframeRef.current.focus();
      try {
        singleIframeRef.current.contentWindow.postMessage('focus', '*');
      } catch {}
    } else if (isParallel) {
      handlePaneFocus(activePane || 'left');
    }
  }, 300);
}}
                 title="Toggle Sidebar">
                    {isCollapsed ? '>' : '‹'}
                </button>
                <div className="control-panel">
                    <div className="control-group">
                      
                <div className="sidebar-logo-top">
                    <img
                        src={isCollapsed ? MiniTevelLogo : FullTevelLogo}
                        alt="Tevel Logo"
                        style={{ width: isCollapsed ? "50px" : "150px" }}
                    />
                    </div>
                        {/* <button className="control-btn"
                            onClick={() => {
                                if (window.opener && !window.opener.closed) {
                                    window.opener.postMessage('focus-me', window.location.origin);
                                    window.opener.focus();
                                } else {
                                    window.close();
                                }
                            }}
                        >
                            <span className="btn-icon">
                                <img src={CRDashboardIcon} alt="Dashboard" />
                            </span>
                            <span className="btn-text">Dashboard</span>
                        </button> */}
                     
                         {vmList && vmList.length > 1 && (
                        <button className="control-btn" onMouseDown={(e) => e.stopPropagation()} onClick={(e) => { e.preventDefault(); setIsParallel(!isParallel); setIsCollapsed(true); }}>
                            <span className="btn-icon">
                                <img src={ParallelIcon} alt="Parallel" />
                            </span>
                            <span className="btn-text">Parallel</span>
                        </button>
                         )}

                                <button className="control-btn" onMouseDown={(e) => e.stopPropagation()} onClick={(e) => { e.preventDefault(); refreshIframe(); }}>
                            <span className="btn-icon">
                                <img src={RefreshIcon} alt="Refresh" />
                            </span>
                            <span className="btn-text">Refresh</span>
                        </button>

                        {vmList && vmList.length > 0 && vmList.map((item, i) => {
                            const vmName = item.vmName.toLowerCase();
                            const icon = vmName.includes('win') ? WindowsIcon : vmName.includes('kali') ? KaliIcon : vmName.includes('ubuntu') ? UbuntuIcon : KaliIcon;
                            return (
                                <button  className={`control-btn ${activeVM === item.connectionId ? 'active-btn' : ''}`} key={i} onMouseDown={(e) => e.stopPropagation()}    onClick={(e) => {
    setActiveVM(item.connectionId);
    showVM(e, item);
  }}
>
                                    <span className="btn-icon"><img src={icon} alt={item.vmName} /> </span>
                                    <span className="btn-text">{item.vmName}</span>
                                </button>
                            );
                        })}
                
                        {/* <button className="control-btn" onClick={(e) => { e.preventDefault(); toggleFullscreen(); }}>
                            <span className="btn-icon">
                                <img src={isFullScreen ? MinimizeIcon : FullScreenIcon} alt={isFullScreen ? 'Minimize' : 'Full Screen'} />
                            </span>
                            <span className="btn-text">{isFullScreen ? 'Minimize' : 'Full Screen'}</span>
                        </button> */}
                      

                    </div>
                </div>
                {/* <div className="instructions-section">
                    <h3 className="instructions-title">Windows VM Instructions</h3>
                    <p className="instructions-welcome">Welcome to your Windows environment!</p>

                    <ul className="tip-list">
                        <li>Use Windows key + R for Run dialog</li>
                        <li>Open PowerShell as Administrator</li>
                    </ul>

                    <h3 className="instructions-title">Kali Linux Instructions</h3>
                    <p className="instructions-welcome">Welcome to your Kali Linux environment!</p>
                    <p className="instructions-tips">Here are some getting started tips:</p>

                    <ul className="tip-list">
                        <li>Open terminal with Ctrl+Alt+T</li>
                        <li>Update system: sudo apt update && sudo apt upgrade</li>
                    </ul>
                </div> */}


<div
className={`${isCollapsed ? "py-1 px-1 t-3 mt-auto" : "p-3 mt-3 mt-auto"}`}
  style={{
    backgroundColor: "#1f2a3a",
    display: "inline-block",
    borderRadius: "8px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.25)"
  }}
>
  <p
    className="text-uppercase fw-semibold mb-2 text-center"
    style={{
      fontSize: "11px",
      letterSpacing: "1px",
      color: "#9aa7bd",
    }}
  >
      {isCollapsed ? "Time" : "Remaining Time"}
  </p>

   <div
    className={`d-flex ${
      isCollapsed
        ? "flex-column gap-2 align-items-center"
        : "gap-2 justify-content-center"
    }`}
  >
    
    {/* Hours */}
    <div
      className="d-flex flex-column justify-content-center align-items-center"
      style={{
        backgroundColor: "#263245",
        width: isCollapsed ? "100%" : "40px",
        height: "45px",
        borderRadius: "8px",
      }}
    >
      <h6 className="fw-bold mb-0 text-white">{hrs}</h6>
      <span
        className="text-uppercase"
        style={{ fontSize: "9px", color: "#9aa7bd" }}
      >
        HR
      </span>
    </div>

    {/* Minutes */}
    <div
      className="d-flex flex-column justify-content-center align-items-center"
      style={{
        backgroundColor: "#263245",
        width: isCollapsed ? "100%" : "40px",
        height: "45px",
        borderRadius: "8px",
      }}
    >
      <h6 className="fw-bold mb-0 text-white">{mins}</h6>
      <span
        className="text-uppercase"
        style={{ fontSize: "9px", color: "#9aa7bd" }}
      >
        MIN
      </span>
    </div>

    {/* Seconds */}
    <div
      className="d-flex flex-column justify-content-center align-items-center"
      style={{
        backgroundColor: "#263245",
        width: isCollapsed ? "100%" : "40px",
        height: "45px",
        borderRadius: "8px",
      }}
    >
      <h6 className="fw-bold mb-0" style={{ color: "#28c76f" }}>
        {secs}
      </h6>
      <span
        className="text-uppercase"
        style={{ fontSize: "9px", color: "#9aa7bd" }}
      >
        SEC
      </span>
    </div>

  </div>
</div>
                <div className="sidebar-logo">
                  
                        <img
                        src={CyberBayLogo}
                        alt="cyber Logo"
                        style={{ width: isCollapsed ? "50px" : "100px" }}
                    />
                    <div className="logo-version">v 2.2.0</div>
                </div>
            </div>

            <div className="main-content">
                {isParallel ? (
                    <div className="vm-panes-container" ref={containerRef}>
                        {isParallel && <div ref={dragOverlayRef} className="vm-drag-overlay" />}
                        <div
                            className={`vm-pane vm-left-pane ${activePane === 'left' ? 'active-pane' : ''}`}
                            ref={leftPaneRef}
                            style={{ width: leftWidth }}
                            onClick={() => handlePaneFocus('left')}
                            onMouseEnter={() => handlePaneFocus('left')}
                        >
                            <iframe
                                ref={leftIframeRef}
                                key={`left-${iframeKey}`}
                                src={vmUrl1}
                                className="w-full vm-iframe"
                                title="Virtual Machine 1"
                                style={{
                                    pointerEvents: activePane === 'left' ? 'auto' : 'none',
                                    zIndex: activePane === 'left' ? 2 : 1
                                }}
                                allow="autoplay; fullscreen; clipboard-read; clipboard-write;"
                                onLoad={() => handleIframeLoad('parallel')}
                            />
                        </div>
                        {isParallel && <> <div
                            className="vm-divider"
                            ref={dividerRef}
                            onClick={(e) => e.stopPropagation()}
                        />
                            <div ref={rightPaneRef}
                                className={`vm-pane vm-right-pane ${activePane === 'right' ? 'active-pane' : ''}`}
                                onClick={() => handlePaneFocus('right')}
                                onMouseEnter={() => handlePaneFocus('right')}
                            >
                                <iframe
                                    ref={rightIframeRef}
                                    key={`right-${iframeKey}`}
                                    src={vmUrl2}
                                    className="w-full vm-iframe"
                                    title="Virtual Machine 2"
                                    style={{
                                        pointerEvents: activePane === 'right' ? 'auto' : 'none',
                                        zIndex: activePane === 'right' ? 2 : 1
                                    }}
                                    allow="autoplay; fullscreen; clipboard-read; clipboard-write;"
                                    onLoad={() => handleIframeLoad('parallel')}
                                />
                            </div>
                        </>}
                    </div>) : (vmUrl ? (
                        <div className="single-vm-container">
                            <iframe
                                key={`single-${iframeKey}`}
                                ref={singleIframeRef}
                                src={vmUrl}
                                width="100%"
                                frameBorder="0"
                                title="Virtual Machine"
                                className="w-full vm-iframe single-vm-iframe"
                                allow="autoplay; fullscreen; clipboard-read; clipboard-write;"
                                onLoad={() => handleIframeLoad('single')}
                            />
                        </div>
                    ) : (<></>))}
            </div>
        </div>
    );
};

export default SplitView;